<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
    fullscreen
  >
    <div class="mt-2 w-full vx-row justify-between">
      <section class="vx-col lg:w-1/2 sm:w-full">
        <main>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>User :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="userObj !== null ? 'color: black;' : 'color: red;'"
                >{{ userObj !== null ? userObj.name : "User Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Nama Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.name !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.name !== null ? formData.name : "Nama Sahabat ZX Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>No. Telepon Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.no_telp !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.no_telp !== null ? formData.no_telp : "No. Telepon Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>NPWP :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="npwp !== null ? 'color: black;' : 'color: red;'"
                >{{ npwp !== null ? npwp : "NPWP Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>FAX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="fax !== null ? 'color: black;' : 'color: red;'"
                >{{ fax !== null ? fax : "FAX Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Email Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.email !== null ? 'color: black;' : 'color: red;'"
                >{{ formData.email !== null ? formData.email : "Email Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Website Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.website !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.website !== null ? formData.website : "Website Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>No. Pengukuhan Lembaga :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="no_pengukuhan !== null ? 'color: black;' : 'color: red;'"
                >{{
                  no_pengukuhan !== null ? no_pengukuhan : "Nomor Pengukuhan Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Tanggal Pengukuhan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="
                  formData.tanggal_Pengukuhan !== null ? 'color: black;' : 'color: red;'
                "
                >{{
                  formData.tanggal_Pengukuhan !== null
                    ? formData.tanggal_Pengukuhan
                    : "Tanggal Pengukuhan Kosong"
                }}</span
              >
            </section>
          </div>
          <!-- <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Zakat Perbulan :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span class="text-xl" :style="zakat_perbulan !== null ? 'color: black;' : 'color: red;'">{{
                zakat_perbulan !== null
                  ? zakat_perbulan
                  : 0 | toCurrency
              }}</span>
            </section>
          </div> -->
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Deskripsi Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span class="text-lg">{{
                formData.keterangan !== null ? formData.keterangan : "Keterangan Kosong"
              }}</span>
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Provinsi :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.provinsi_id !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.provinsi_id !== null
                    ? provinsiList.find((v) => v.id === formData.provinsi_id).name
                    : "Provinsi Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Kabupaten/Kota :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.kabkot_id !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.kabkot_id !== null
                    ? kabkotList.find((v) => v.id === formData.kabkot_id).name
                    : "Kabupaten/Kota Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Alamat Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.alamat !== null ? 'color: black;' : 'color: red;'"
                >{{ formData.alamat !== null ? formData.alamat : "Alamat Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Nama Seorang Perwakilan Sahabat ZX :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="formData.name_person !== null ? 'color: black;' : 'color: red;'"
                >{{
                  formData.name_person !== null ? formData.name_person : "Nama PIC Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6>
                <strong>No.Telepon Seorang Perwakilan Sahabat ZX :</strong>
              </h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="
                  formData.no_telp_person !== null ? 'color: black;' : 'color: red;'
                "
                >{{
                  formData.no_telp_person !== null
                    ? formData.no_telp_person
                    : "Nomor Telepon PIC Kosong"
                }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Status Lembaga :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="stLembagaObj !== null ? 'color: black;' : 'color: red;'"
                >{{ stLembagaObj ? stLembagaObj.name : "Status Lembaga Kosong" }}</span
              >
            </section>
          </div>
          <div class="mb-6">
            <section class="mb-2 flex justify-start gap-1">
              <h6><strong>Status UPZ :</strong></h6>
            </section>
            <section class="w-full break-words">
              <span
                class="text-xl"
                :style="stUpzOBj !== null ? 'color: black;' : 'color: red;'"
                >{{ stUpzOBj ? stUpzOBj.name : "Status UPZ Kosong" }}</span
              >
            </section>
          </div>
        </main>
      </section>

      <section class="vx-col lg:w-1/2 sm:w-full">
        <main>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Foto Kantor</strong></h6>
              <!-- <span class="text-danger">*</span> -->
            </section>
            <div class="gap-4 items-center mb-4">
              <img
                :src="
                  formData.file_kantor !== emptyImage
                    ? formData.file_kantor.includes('upload//')
                      ? `${url.baseFl}/${formData.file_kantor}`
                      : formData.file_kantor
                    : formData.file_kantor
                "
                alt="file-kantor-img"
                class="rounded-lg shadow-md cursor-pointer block mb-4 w-full"
              />
              <div>
                <input
                  type="file"
                  class="hidden"
                  ref="updateImg"
                  @change="updateCurrFileFoto"
                  accept="image/*"
                />
                <a
                  v-if="formData.file_kantor !== emptyImage"
                  :href="
                    formData.file_kantor !== emptyImage
                      ? formData.file_kantor.includes('upload//')
                        ? `${url.baseFl}/${formData.file_kantor}`
                        : formData.file_kantor
                      : formData.file_kantor
                  "
                  target="_blank"
                  >Download Foto Kantor</a
                >
                <p v-else style="color: red">Foto tidak ada</p>
                <!-- <vs-button
              class="mr-4 sm:mb-0 mb-2"
              @click="$refs.updateImg.click()"
              >Download Foto Kantor</vs-button
            > -->
                <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
              </div>
            </div>
          </div>
          <div class="mb-6">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Surat Keterangan</strong></h6>
              <!-- <span class="text-danger">*</span> -->
            </section>
            <div class="flex justify-start w-full gap-4 items-center mb-4">
              <vs-icon
                v-if="formData.file_sk === null"
                icon="attach_file"
                size="medium"
                color="grey"
                bg="white"
                rounded
              ></vs-icon>
              <div
                v-else
                class="rounded-lg shadow-md bg-grey cursor-pointer block mb-4 p-6 place-items-center"
              >
                <h2>
                  <strong>{{
                    binaryFileSK !== ""
                      ? binaryFileSK.name.split(".").slice(-1)[0]
                      : formData.file_sk !== null
                      ? formData.file_sk.split(".").slice(-1)[0]
                      : ""
                  }}</strong>
                </h2>
              </div>
              <div>
                <p class="text-black text-sm mb-2" v-if="formData.file_sk !== null">
                  {{
                    binaryFileSK !== ""
                      ? binaryFileSK.name.split("/").slice(-1)[0]
                      : formData.file_sk !== null
                      ? formData.file_sk.split("/").slice(-1)[0]
                      : "Tidak ada surat keterangan"
                  }}
                </p>
                <p v-else class="text-sm mb-2" style="color: red">
                  Tidak ada surat keterangan
                </p>
                <a
                  v-if="formData.file_sk !== null"
                  :href="`${url.baseFl}/${formData.file_sk}`"
                  target="_blank"
                  >Download File SK</a
                >
                <!-- <input
              type="file"
              class="hidden"
              ref="updateSK"
              @change="updateCurrFileSK"
              accept=".pdf,.doc,.docx,.xls,.ppt,.pptx,.png,.jpeg,.jpg,.txt,.zip,.rar,.z7,.gz"
            /> -->
                <!-- <vs-button
              class="mr-4 sm:mb-0 mb-2"
              @click="$refs.updateSK.click()"
              >Download File SK</vs-button
            > -->
                <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
              </div>
            </div>
          </div>
          <div class="mb-10">
            <section class="mb-4 flex justify-start gap-1">
              <h6><strong>Surat Penunjukan</strong></h6>
              <!-- <span class="text-danger">*</span> -->
            </section>
            <div class="flex justify-start w-full gap-4 items-center mb-4">
              <vs-icon
                v-if="formData.file_penunjukan === null"
                icon="attach_file"
                size="medium"
                color="grey"
                bg="white"
                rounded
              ></vs-icon>
              <div
                v-else
                class="rounded-lg shadow-md bg-grey cursor-pointer block mb-4 p-6 place-items-center"
              >
                <h2>
                  <strong>{{
                    binaryFilePenunjukan !== ""
                      ? binaryFilePenunjukan.name.split(".").slice(-1)[0]
                      : formData.file_penunjukan !== null
                      ? formData.file_penunjukan.split(".").slice(-1)[0]
                      : ""
                  }}</strong>
                </h2>
              </div>
              <div>
                <p
                  class="text-black text-sm mb-2"
                  v-if="formData.file_penunjukan !== null"
                >
                  {{
                    binaryFilePenunjukan !== ""
                      ? binaryFilePenunjukan.name.split("/").slice(-1)[0]
                      : formData.file_penunjukan !== null
                      ? formData.file_penunjukan.split("/").slice(-1)[0]
                      : ""
                  }}
                </p>
                <p v-else class="text-sm mb-2" style="color: red">
                  Tidak ada surat penunjukan
                </p>
                <a
                  v-if="formData.file_penunjukan !== null"
                  :href="`${url.baseFl}/${formData.file_penunjukan}`"
                  target="_blank"
                  >Download File Penunjukan</a
                >
                <!-- <input
              type="file"
              class="hidden"
              ref="updatePenunjukan"
              @change="updateCurrFilePenunjukan"
              accept=".pdf,.doc,.docx,.xls,.ppt,.pptx,.png,.jpeg,.jpg,.txt,.zip,.rar,.z7,.gz"
            /> -->
                <!-- <vs-button
              class="mr-4 sm:mb-0 mb-2"
              @click="$refs.updatePenunjukan.click()"
              >Download Surat Penunjukan</vs-button
            > -->
                <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
              </div>
            </div>
          </div>
        </main>
      </section>
      <!-- <div class="vx-col w-full mb-8">
        <p class="mb-4 flex justify-end"><strong>Aproval Sahabat ZX</strong></p>
        <div class="flex justify-end gap-2">
          <p>{{ statusUser ? "Disetujui" : "Tidak Disetujui" }}</p>
          <vs-switch
            :color="statusUser ? 'success' : 'danger'"
            v-model="statusUser"
          />
        </div>
      </div> -->
    </div>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="updateUser(0)"
          >Tidak Disetujui</vs-button
        >
        <vs-button color="success" class="ml-2 rounded-2xl" @click="updateUser(1)"
          >Disetujui</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import url from "@/url.js";

export default {
  components: {
    VuePhoneNumberInput,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
    userList: { type: Array, default: [] },
  },
  data() {
    return {
      url,
      emptyImage,
      binaryFileSK: "",
      binaryFilePenunjukan: "",
      binaryFoto: "",
      kabkotList: [],
      statusLembaga: [
        {
          id: 1,
          text: "Sebagai Organisasi Pengelola Zakat (OPZ)",
        },
        {
          id: 2,
          text: "Bukan Organisasi Pengelola Zakat (Non-OPZ)",
        },
      ],
      statusUpz: [
        {
          id: 1,
          text: "Aktif",
        },
        {
          id: 0,
          text: "Tidak Aktif",
        },
      ],
      stLembagaObj: null,
      stUpzOBj: null,
      userObj: null,
      npwp: null,
      fax: null,
      zakat_perbulan: null,
      no_pengukuhan: null,
      statusUser: false,
      formData: {
        user_id: null,
        status_upz: 1,
        name: "",
        status_lembaga: 1,
        email: "",
        website: "",
        no_telp_person: null,
        tanggal_Pengukuhan: "",
        keterangan: "",
        alamat: "",
        provinsi_id: null,
        kabkot_id: null,
        name_person: "",
        email_person: "",
        file_sk: "",
        no_telp: "",
        file_kantor: emptyImage,
        file_penunjukan: "",
      },
    };
  },
  computed: {
    provinsiList() {
      return this.$store.state.wilayah.provinsiList;
    },
    provinsiSelect() {
      return this.formData.provinsi_id;
    },
    userCompute() {
      return this.formData.user_id;
    },
    titlePopUp() {
      return this.passData != null ? "Edit Sahabat ZX" : "Tambah Sahabat ZX";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.user_id !== null &&
        this.formData.status_upz !== null &&
        this.formData.name !== "" &&
        this.formData.no_telp !== "" &&
        this.formData.status_lembaga !== null &&
        this.npwp !== null &&
        this.fax !== null &&
        this.formData.email !== "" &&
        this.no_pengukuhan !== null &&
        this.formData.website !== "" &&
        this.formData.tanggal_Pengukuhan !== "" &&
        this.zakat_perbulan !== null &&
        this.formData.keterangan !== "" &&
        this.formData.alamat !== "" &&
        this.formData.name_person !== "" &&
        this.formData.no_telp_person !== "" &&
        this.formData.email_person !== "" &&
        this.formData.file_sk !== "" &&
        this.formData.file_kantor !== "" &&
        this.formData.file_penunjukan !== "" &&
        this.formData.provinsi_id !== null &&
        this.formData.kabkot_id !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.stLembagaObj = this.passData.status_lembaga;
        this.stUpzOBj = this.passData.status_upz;
        this.statusUser = this.passData.user.status == 1;
        this.userObj = this.passData.user;
        this.formData.user_id = this.passData.user.id;
        this.formData.status_upz = this.passData.status_upz
          ? this.passData.status_upz.id
          : null;
        this.formData.name = this.passData.name;
        this.formData.no_telp = this.passData.user.no_telp;
        this.formData.status_lembaga = this.passData.status_lembaga
          ? this.passData.status_lembaga.id
          : null;
        this.npwp = this.passData.npwp;
        this.fax = this.passData.fax;
        this.formData.provinsi_id =
          this.passData.kabkot != null
            ? this.passData.kabkot.provinsi != null
              ? this.passData.kabkot.provinsi.id
              : null
            : null;
        this.formData.kabkot_id =
          this.passData.kabkot != null ? this.passData.kabkot.id : null;
        this.formData.email = this.passData.user.email;
        this.no_pengukuhan = this.passData.no_pengukuhan;
        this.formData.website = this.passData.website;
        this.formData.tanggal_Pengukuhan = this.passData.tanggal_Pengukuhan;
        this.zakat_perbulan = this.passData.zakat_perbulan;
        this.formData.keterangan = this.passData.keterangan;
        this.formData.alamat = this.passData.alamat;
        this.formData.name_person = this.passData.name_person;
        this.formData.no_telp_person = this.passData.no_telp_person;
        this.formData.email_person = this.passData.email_person;
        this.formData.file_sk =
          this.passData.file_sk !== null
            ? this.passData.file_sk.includes(`${this.url.baseFl}/`)
              ? this.passData.file_sk.split(`${this.url.baseFl}/`)[1]
              : this.passData.file_sk
            : null;
        this.formData.file_kantor =
          this.passData.file_kantor !== null
            ? this.passData.file_kantor.includes(`${this.url.baseFl}/`)
              ? this.passData.file_kantor.split(`${this.url.baseFl}/`)[1]
              : this.passData.file_kantor
            : this.emptyImage;
        this.formData.file_penunjukan =
          this.passData.file_penunjukan !== null
            ? this.passData.file_penunjukan.includes(`${this.url.baseFl}/`)
              ? this.passData.file_penunjukan.split(`${this.url.baseFl}/`)[1]
              : this.passData.file_penunjukan
            : null;
      } else {
        this.resetForm();
      }
    },
    provinsiSelect() {
      if (this.formData.provinsi_id !== null) {
        this.kabkotList = this.$store.getters["wilayah/getFilteredKabKot"](
          this.formData.provinsi_id
        );
      }
    },
    userCompute() {
      if (this.formData.user_id !== null) {
        let user = this.userList.find((v) => v.id === this.formData.user_id);
        this.formData.no_telp = user.no_telp;
        this.formData.email = user.email;
      }
    },
  },
  methods: {
    resetForm() {
      this.stUpzOBj = null;
      this.stLembagaObj = null;
      this.userObj = null;
      this.formData.user_id = null;
      this.formData.status_upz = 1;
      this.formData.name = "";
      this.formData.no_telp = "";
      this.formData.status_lembaga = 1;
      this.npwp = null;
      this.fax = null;
      this.formData.provinsi_id = null;
      this.formData.kabkot_id = null;
      this.formData.email = "";
      this.no_pengukuhan = null;
      this.formData.website = "";
      this.formData.tanggal_Pengukuhan = "";
      this.zakat_perbulan = null;
      this.formData.keterangan = "";
      this.formData.alamat = "";
      this.formData.name_person = "";
      this.formData.no_telp_person = "";
      this.formData.email_person = "";
      this.formData.file_sk = "";
      this.formData.file_kantor = this.emptyImage;
      this.formData.file_penunjukan = "";
      this.binaryFileSK = "";
      this.binaryFilePenunjukan = "";
      this.binaryFoto = "";
      this.statusUser = false;
    },
    profile() {
      return JSON.parse(localStorage.getItem("profileAccess")).data;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      if (this.formData.file_sk === "") {
        this.$vs.notify({
          position: "top-right",
          title: "File SK Kosong!!",
          text: "Upload file SK terlebih dahulu",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }

      if (this.formData.file_kantor === "") {
        this.$vs.notify({
          position: "top-right",
          title: "Foto Kantor Kosong!!",
          text: "Upload foto kantor terlebih dahulu",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }

      if (this.formData.file_penunjukan === "") {
        this.$vs.notify({
          position: "top-right",
          title: "File Penunjukan Kosong!!",
          text: "Upload file penunjukan terlebih dahulu",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }
      return new Promise((resolve, reject) => {
        this.$vs.loading({
          color: "primary",
        });

        if (this.binaryFileSK !== "") {
          this.addWithFileSK();
        }

        if (this.binaryFilePenunjukan !== "") {
          this.addWithFilePenunjukan();
        }

        if (this.binaryFoto !== "") {
          this.addWithFileFoto();
        }

        resolve(this.addData());
      });
    },
    addWithFileFoto() {
      this.$store
        .dispatch("file/addFile", this.binaryFoto)
        .then((v) => {
          this.formData.file_kantor = v.link;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addWithFilePenunjukan() {
      this.$store
        .dispatch("file/addFile", this.binaryFilePenunjukan)
        .then((v) => {
          this.formData.file_penunjukan = v.link;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addWithFileSK() {
      this.$store
        .dispatch("file/addFile", this.binaryFileSK)
        .then((v) => {
          this.formData.file_sk = v.link;
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file_kantor === this.emptyImage) {
        this.formData.file_kantor = null;
      }
      this.$store
        .dispatch("lembaga/cudLembaga", [
          {
            ...this.formData,
            ...id,
            npwp: Number.parseInt(this.npwp),
            fax: Number.parseInt(this.fax),
            no_pengukuhan: Number.parseInt(this.no_pengukuhan),
            zakat_perbulan: Number.parseInt(this.zakat_perbulan),
          },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null ? "Edit Lembaga Sukses!" : "Tambah Lembaga Sukses!",
            text:
              this.passData !== null
                ? `Lembaga ${v.name} Berhasil diedit`
                : `Lembaga ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
          this.$vs.loading.close();
        });
    },
    updateUser(id) {
      this.$vs.loading({
        color: "primary",
      });
      let user = this.userList.find((v) => v.id === this.formData.user_id);
      this.$store
        .dispatch("users/cudUsers", [
          {
            id: user.id,
            level_id: user.level.id,
            status: id,
            name: user.name,
            email: user.email,
            no_telp: user.no_telp,
          },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Status Sahabat ZX Sukses!"
                : "Tambah Status Sahabat ZX Sukses!",
            text:
              this.passData !== null
                ? `Status Sahabat ZX ${v.name} Berhasil diedit`
                : `Status Sahabat ZX ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();

          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
    updateCurrFileSK(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_sk = e.target.result;
          this.binaryFileSK = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrFilePenunjukan(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_penunjukan = e.target.result;
          this.binaryFilePenunjukan = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    updateCurrFileFoto(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file_kantor = e.target.result;
          this.binaryFoto = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  max-height: 400px;
  max-width: 100%;
  overflow: auto;
}
</style>
